import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyD6p1utoSTPSPfI2Hd2C613MTJmnKwFe30',
  authDomain: 'modern-leaf-9e05b.firebaseapp.com',
  projectId: 'modern-leaf-9e05b',
  storageBucket: 'modern-leaf-9e05b.firebasestorage.app',
  messagingSenderId: '194110481618',
  appId: '1:194110481618:web:90fc8237a8665b95ce790b',
  measurementId: 'G-P8DN4J7DQJ',
}

const firebaseApp = initializeApp(firebaseConfig)

export const firebaseAuth = getAuth(firebaseApp)
export const firestore = getFirestore(firebaseApp)
export const firebaseFunctions = getFunctions(firebaseApp)
export const firebaseStorage = getStorage(firebaseApp)
